import React, { useRef, useState } from "react";
import { Formik, Form, ErrorMessage } from "formik";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import Cookies from "js-cookie";
import { redressWidget } from "../../api";
import { renameZoneWidget } from "../../redux";
import { Alert } from "../";
import { useTranslation } from "react-i18next";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { withRouter } from "react-router-dom";
import { IconsList } from ".";
import { ModalComp } from "../";

const EditWidgetComp = (props) => {
  const { t } = useTranslation();
  const [openIconModal, setOpenIconModal] = useState(false);
  const toggleIcon = () => setOpenIconModal(!openIconModal);
  const { zone, toggleEdit } = props;
  const dispatch = useDispatch();
  const icons = useSelector((state) => state.icons);
  let form = useRef();
  let caption = useRef();
  const token = Cookies.get("token");
  const [isOpen, setIsOpen] = useState(false);
  const [widgetStatus, setWidgetStatus] = useState(zone.property[4]);
  const toggle = () => setIsOpen((prevState) => !prevState);
  const [icon, setIcon] = useState(
    zone.property[2] === "image_path"
      ? "https://assessn.mmaviot.com/icon/app/005-smart-control.png"
      : zone.property[2]
  );
  // console.log(zone);
  const [visible, setVisible] = useState(zone.property[3]);

  const initialValues = {
    caption: zone.caption,
    configuration: zone.property[4],
  };

  const visibleChanged = (e) => {
    if (e.target.checked) {
      setVisible("0");
    } else {
      setVisible("1");
    }
  };

  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });

  const submitForm = (val) => {
    const data = new FormData(form.current);
    data.append("serial", zone.serial);
    data.append("widget", zone.id);
    data.append("icon", icon);
    data.append("visible", visible);
    redressWidget(data, token)
      .then(() => {
        setShowAlert((prevState) => ({
          ...prevState,
          show: true,
          message: t("ویجت با موفقیت ویرایش شد."),
          type: "Success",
        }));
        setTimeout(() => {
          setShowAlert((prevState) => ({
            ...prevState,
            show: false,
          }));
          toggleEdit();
          dispatch(
            renameZoneWidget({
              genome: zone.genome,
              caption: val.caption,
              visible: visible,
              configuration: val.configuration,
              icon: icon,
            })
          );
        }, 2000);
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
            type: "Error",
          }));
          setTimeout(() => {
            setShowAlert((prevState) => ({
              ...prevState,
              show: false,
            }));
          }, 2000);
        }
      });
  };

  const validationSchema = Yup.object({
    caption: Yup.string().required(t("نام ویجت را وارد کنید.")),
    configuration: Yup.string().required(t("تنظیمات ویجت را وارد کنید.")),
  });

  return (
    <>
      <ModalComp
        modal={openIconModal}
        toggle={toggleIcon}
        component={
          <IconsList icons={icons} toggleIcon={toggleIcon} setIcon={setIcon} />
        }
      />
      <div style={{ minHeight: "60vh" }}>
        <div>
          <i className="circleTop icon-plug text-center m-auto"></i>
          <div className="text-center mt-2">
            <p className="m-0">{t("ویرایش ویجت")}</p>
          </div>
        </div>
        <Formik
          initialValues={initialValues}
          onSubmit={submitForm}
          validationSchema={validationSchema}
        >
          {(props) => (
            <Form ref={form}>
              <div className="my-4">
                <p className="fn mb-2 text-right"> {t("نام ویجت")}</p>
                <div className="inputs d-flex flex-column justify-content-center w-100 px-3">
                  <input
                    type="text"
                    placeholder={t("نام ویجت")}
                    name="caption"
                    className="w-100 text-right fn"
                    defaultValue={props.values.caption}
                    onChange={props.handleChange}
                    onBlur={props.handleBlur}
                    ref={caption}
                  />
                </div>
                <ErrorMessage name="caption">
                  {(errMsg) => (
                    <div className="text-danger text-right fn10 mt-1">
                      {errMsg}
                    </div>
                  )}
                </ErrorMessage>
              </div>
              <div className="my-4">
                <p className="fn mb-2 text-right">{t("وضعیت ویجت")} </p>
                <div className="text-right">
                  <div
                    className={`${
                      widgetStatus === "Conf1" ? "widgetStatusActive" : ""
                    } d-flex align-items-center pr-3`}
                    style={{ height: "54px" }}
                  >
                    <input
                      type="radio"
                      id="onOff"
                      value="Conf1"
                      name="configuration"
                      className="mx-1"
                      onChange={props.handleChange}
                      onClick={() => setWidgetStatus("Conf1")}
                      onBlur={props.handleBlur}
                      defaultChecked={
                        zone.property[4] === "Conf1" ? true : false
                      }
                    />
                    <label for="onOff" className="fn mr-3 mx-1">
                      {t("خاموش و روشن")}
                    </label>
                  </div>
                  {zone.commands.length > 2 && (
                    <div
                      className={`${
                        widgetStatus === "Conf2" ? "widgetStatusActive" : ""
                      } d-flex align-items-center pr-3`}
                      style={{ height: "54px" }}
                    >
                      <input
                        type="radio"
                        id="sentences"
                        value="Conf2"
                        name="configuration"
                        onChange={props.handleChange}
                        onClick={() => setWidgetStatus("Conf2")}
                        onBlur={props.handleBlur}
                        defaultChecked={
                          zone.property[4] === "Conf2" ? true : false
                        }
                      />
                      <label for="sentences" className="fn mr-3">
                        {t("تحریک")}
                      </label>
                    </div>
                  )}
                </div>
                <ErrorMessage name="configuration">
                  {(errMsg) => (
                    <div className="text-danger fn10 mt-1">{errMsg}</div>
                  )}
                </ErrorMessage>
              </div>
              <div className="my-4 text-right">
                <p className="fn mb-2 text-right">{t("سایر تنظیمات")}</p>
                <div className="inputs px-3 d-flex justify-content-between align-items-center">
                  <p className="m-0 fn">{t("آیکون ویجت")}</p>
                  <div
                    onClick={toggleIcon}
                    className="changeWidgetIcon cursor text-center rounded-circle"
                  >
                    <img width="20" height="20" src={icon} />
                  </div>
                </div>
              </div>
              <div className="mt-4">
                <div className="w-100 inputs px-3 text-right mb-3 d-flex align-items-center justify-content-between">
                  <p className="fn m-0">{t("ویجت پنهان")}</p>
                  <label className="switchDevice">
                    <input
                      type="checkbox"
                      id="myCheck"
                      defaultChecked={visible === "0" ? true : false}
                      onChange={visibleChanged}
                    />
                    <span className="switchSliderDevice round"></span>
                  </label>
                </div>
              </div>
              <div className="d-flex flex-wrap justify-content-center mt-4">
                <button
                  type="submit"
                  className="border-0 bg-transparent mx-3 d-flex justify-content-center align-items-center flex-column text-center"
                >
                  <span className="profileAddUser bg-white d-block icon-ok cursor"></span>
                  <small className="fn12 mt-1">{t("تائید")}</small>
                </button>
              </div>
            </Form>
          )}
        </Formik>
        {showAlert.show && (
          <Alert message={showAlert.message} type={showAlert.type} />
        )}
      </div>
    </>
  );
};

const EditWidget = withRouter(EditWidgetComp);

export { EditWidget };
